



































































import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { JobEntry } from '@/api/job/JobEntry';
import JobResource from '@/api/job/JobResource';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';


interface JobTableEntry {
	fiId: number | null;
	coreProcessingDate: Date;
	creationTime: string | null;
	sortableCreationTime: number | null;
	startTime: string | null;
	sortableStartTime: number | null;
	friendlyStartTime: string;
	friendlyCreationTime: string;
	requiresProcessing: string;
	reloadId: string;
	transformJobType: string;
}

@Component({
  components: {
	    KCardHeader, KCardHeaderBtn,
  },
})
export default class JobQueue extends Vue {
	@Inject('JobResource')
	private jobResource!: JobResource;

	headerItems: any = [{
	  text: 'Tech Ops Admin',
	  disabled: false,
	  link: false,
	},
	{
	  text: 'Job Queue',
	  disabled: true,
	}];

	loading: boolean = false;

	jobsRunningLoading: boolean = false;

	itemsPerPagePreference: any = -1;

	footerProps: any = {
	  'items-per-page-options': [15, 30, 90, { value: -1, text: 'All' }],
	};

	activeHeaders: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Core Processing Date', value: 'coreProcessingDate' },
	];

	standardHeaders: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Core Processing Date', value: 'coreProcessingDate' },
	];

	directorJobQueueHeaders: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Creation Time', value: 'sortableCreationTime' },
	  { text: 'Core Processing Date', value: 'coreProcessingDate' },
	  { text: 'Reload ID', value: 'reloadId' },
	];

	uffQueueHeaders: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Creation Time', value: 'sortableCreationTime' },
	  { text: 'Core Processing Date', value: 'coreProcessingDate' },
	  { text: 'Transformation Type', value: 'transformJobType' },
	];

	directorJobsRunningHeaders: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Start Time', value: 'sortableStartTime' },
	  { text: 'Core Processing Date', value: 'coreProcessingDate' },
	  { text: 'Process Quals/Rewards', value: 'requiresProcessing' },
	];

	items: JobTableEntry[] = [];

	jobsRunningItems: any = [];

	service: string = 'Director';

	headers: any = this.directorJobQueueHeaders;

	queueSortBy:string = '';

	services: string[] = ['Director', 'ASCAD', 'UFF Transformation'];

	static friendlyTransformJobTypeNames = new Map([
	  ['UFF_ADDRESSES', 'Addresses'],
	  ['UFF_CIF', 'CIF'],
	  ['UFF_DEPOSITS', 'Deposits'],
	  ['UFF_EMAIL_ADDRESSES', 'Email Addresses'],
	  ['UFF_INTERNET_BANKING_LOGINS', 'Internet Banking Logins'],
	  ['UFF_LOANS', 'Loans'],
	  ['UFF_RELATIONSHIPS', 'Relationships'],
	  ['UFF_TRANSACTIONS', 'Transactions'],
	]);

	mounted() {
	  this.reloadAll();
	  this.queueSortBy = 'sortableCreationTime';
	}

	private reloadAll() {
	  if (sessionStorage.getItem('jobqueue-itemsPerPagePreference')) {
	    this.itemsPerPagePreference = parseInt(
	      `${sessionStorage.getItem('jobqueue-itemsPerPagePreference')}`,
	      10,
	    );
	  } else {
	    this.itemsPerPagePreference = 15;
	  }
	  this.loadQueue();
	}

	loadQueue() {
	  this.items = [];
	  this.jobsRunningItems = [];
	  this.loading = true;
	  if (this.service === 'Director') {
		  this.jobsRunningLoading = true;
	    this.jobResource
	      .getAllPendingDirectorJobs()
	      .then((result: JobEntry[]) => {
	        JobQueue.buildJobTableEntries(result, this.items);
	        this.activeHeaders = this.directorJobQueueHeaders;
	      })
	      .catch((error: any) => {
	        this.showError(error);
	      }).finally(() => {
			  this.loading = false;
		  });
	    this.jobResource
	      .getAllProcessingDirectorJobs()
	      .then((result: JobEntry[]) => {
	        JobQueue.buildJobTableEntries(result, this.jobsRunningItems);
	      })
	      .catch((error: any) => {
	        this.showError(error);
	      }).finally(() => {
			  this.jobsRunningLoading = false;
		  });
	  } else if (this.service === 'ASCAD') {
	    this.jobResource
	      .getAllProcessingAscadJobs()
	      .then((result: JobEntry[]) => {
	        JobQueue.buildJobTableEntries(result, this.items);
	        this.activeHeaders = this.standardHeaders;
	      })
	      .catch((error: any) => {
	        this.showError(error);
	      }).finally(() => {
			  this.loading = false;
		  });
	  } else if (this.service === 'UFF Transformation') {
	    this.jobResource
	      .getAllProcessingUffJobs()
	      .then((result: JobEntry[]) => {
	        JobQueue.buildJobTableEntries(result, this.items);
	        this.activeHeaders = this.standardHeaders;
	      })
	      .catch((error: any) => {
	        this.showError(error);
	      }).finally(() => {
			  this.loading = false;
		  });
	  }
	}

	@Watch('service')
	onServiceChanged(value: string, oldValue: string) {
	  if (value === 'Director') {
	    this.headers = this.directorJobQueueHeaders;
	    this.queueSortBy = 'sortableCreationTime';
	  } else if (value === 'UFF Transformation') {
	    this.headers = this.uffQueueHeaders;
	    this.queueSortBy = 'sortableCreationTime';
	  } else {
	    this.headers = this.standardHeaders;
	    this.queueSortBy = 'coreProcessingDate';
	  }

	  this.items = [];
	  this.jobsRunningItems = [];
	  this.loadQueue();
	}

	showError(error: any) {
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.setError(error.response.data.entity);
	  } else {
	    this.setError('An unexpected error occurred.');
	  }
	}

	setError(message: string) {
	  const al = new Alert(message, NoticeClass.ERROR);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}

	static buildJobTableEntries(jobItems: JobEntry[], items: JobTableEntry[]) {
	  for (let i = 0; i < jobItems.length; i++) {
	    items.push(JobQueue.buildTableEntry(jobItems[i]));
	  }
	}

	static buildTableEntry(item: JobEntry): JobTableEntry {
	  return {
	    fiId: item.fiId,
	    coreProcessingDate: item.coreProcessingDate,
	    creationTime: item.creationTime,
	    sortableCreationTime:
				item.creationTime !== null
				  ? new Date(item.creationTime).getTime()
				  : null,
	    startTime: item.startTime,
	    sortableStartTime:
				item.startTime !== null ? new Date(item.startTime).getTime() : null,
	    friendlyStartTime:
				item.startTime !== null
				  ? `${new Date(item.startTime).toLocaleDateString()} ${new Date(
				    item.startTime,
					  ).toLocaleTimeString()}`
				  : '',
	    friendlyCreationTime:
				item.creationTime !== null
				  ? `${new Date(item.creationTime).toLocaleDateString()} ${new Date(
				    item.creationTime,
					  ).toLocaleTimeString()}`
				  : '',
	    requiresProcessing: item.requiresProcessing,
	    reloadId: item.reloadId,
	    transformJobType: JobQueue.getFriendlyTransformJobType(item.transformJobType),
	  };
	}

	static getFriendlyTransformJobType(transformJobType : string | null) {
	  let friendlyName = '?';
	  if (transformJobType) {
	    if (JobQueue.friendlyTransformJobTypeNames.has(transformJobType)) {
	      friendlyName = JobQueue.friendlyTransformJobTypeNames.get(transformJobType)!;
	    }
	  }
	  return friendlyName;
	}

	@Watch('itemsPerPagePreference')
	rememberItemPerPage(selectedValue: number) {
	  sessionStorage.setItem(
	    'jobqueue-itemsPerPagePreference',
	    JSON.stringify(selectedValue),
	  );
	  this.itemsPerPagePreference = selectedValue;
	}
}
